import { useTranslation } from 'react-i18next';

import { AgGridServerTable } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { ISelectionAction } from 'core/types';
import { IAttributePartPayload, IQuotePart } from 'quotes/types';
import { Color, Variant } from 'theme/enums';

interface IProps {
  onClose: () => void;
  onAttachParts: (parts: IAttributePartPayload[]) => Promise<{ newRows: IQuotePart[] }>;
}

export const Table = ({ onClose, onAttachParts }: IProps) => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  const selectionActions = (): ISelectionAction[] => [
    {
      label: t('buttonLabelAttachSelectedParts', {
        count: selectedRows?.length,
      }),
      color: Color.SUCCESS,
      variant: Variant.SOLID,
      onClick: () => handleAttachParts(),
    },
  ];

  const handleAttachParts = async () => {
    onClose();

    const { newRows } =
      onAttachParts &&
      (await onAttachParts(
        selectedRows.map((selectedRow) => ({
          part: selectedRow.number,
          uom: selectedRow.uom,
          quantity: selectedRow.quantity,
          manufacturerId: selectedRow.manufacturerId,
        }))
      ));

    if (!newRows) {
      return false;
    }

    return true;
  };

  return <AgGridServerTable selectionActions={selectionActions} />;
};
